export default {
  'en-US': {
    Title: { // First Page
      Header: {
        Content: 'Customize your Onboarding Checklist',
        Places: {
        }
      },
      SubText: {
        Content: `Logistics is a complicated business, and we want to set \
        you up for success. Please answer the following questions to create \
        your personalized account setup checklist.{br}{br2} \
        It should take 2 minutes, and you can resume or edit your answers at \
        any time.`,
        Places: {
        }
      },
      Helper: {
        Content: ` `,
        Places: {
        }
      },
      Submit: {
        Content: 'Start',
        Places: {
        }
      }
    },
    Stores: { // Second Page
      Header: {
        Content: 'Do you have more than one ecommerce store? (e.g. Shopify and Amazon)',
        Places: {
        }
      },
      SubText: {
        Content: `If so we'll need to match your inventory from one store \
        to the other. This allows us to use fewer locations in the \
        fulfillment center and charge you less for storage.`,
        Places: {
        }
      },
      Helper: {
        Content: ` `,
        Places: {
        }
      },
      Submit: {
        Content: 'Next - Shipping Internationally',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `Yes, I want ShipBob to fulfill orders from multiple stores`,
          Places: {}
        },
        No: {
          Content: `No, I just have one store to fulfill from right now`,
          Places: {}
        }
      }
    },
    International: { // Third Page
      Header: {
        Content: 'Shipping orders internationally?',
        Places: {
        }
      },
      SubText: {
        Content: `If you ship orders internationally, you'll need to \
        add tariff codes to your products to avoid delays at customs \
        and returned orders.`,
        Places: {
        }
      },
      Helper: {
        Content: `Select 'Yes' even if the occurrence will be rare.`,
        Places: {
        }
      },
      Submit: {
        Content: 'Next - Heavy or Large Items',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `I will ship items outside of the United States`,
          Places: {}
        },
        No: {
          Content: `All of my orders will ship within the United States`,
          Places: {}
        }
      }
    },
    HeavyLarge: { // Fourth Page
      Header: {
        Content: 'Shipping heavy or large orders?',
        Places: {
        }
      },
      SubText: {
        Content: `Orders that weight over 1 lb are subject to Dimensional \
        Weight, a formula that charges you according to the size of the \
        item. It may affect your pricing! Orders over 50lbs may require \
        custom setup and be subject to carrier surcharges`,
        Places: {
        }
      },
      Helper: {
        Content: `Select 'Yes' even if the occurrence will be rare.`,
        Places: {
        }
      },
      Submit: {
        Content: 'Next - Shipping Speeds',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `I will be shipping orders that weight more than \
          1Lb (''0.5kg)`,
          Places: {}
        },
        No: {
          Content: `I don't plan to ship orders that weigh more than \
          1Lb (''0.5kg)`,
          Places: {}
        }
      }
    },
    ShipSpeeds: { // Fifth Page
      Header: {
        Content: 'Do you offer shipping speeds other than Ground?',
        Places: {
        }
      },
      SubText: {
        Content: `You may need to map the shipping options you provide \
        your customers to the appropriate speed for your ShipBob orders.\
        If you don’t, everything will go out at Standard (Ground) speed shipping.`,
        Places: {
        }
      },
      Helper: {
        Content: `Select 'Yes' even if it's something  you don't need now \
        but might later.`,
        Places: {
        }
      },
      Submit: {
        Content: 'Next - Bundled Products',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `Yes, I offer my consumers multiple shipping speeds`,
          Places: {}
        },
        No: {
          Content: `No, all of my orders go out at ground rates`,
          Places: {}
        }
      }
    },
    Bundle: { // Sixth Page
      Header: {
        Content: 'Do you have any bundled products?',
        Places: {
        }
      },
      SubText: {
        Content: `Bundled products occur when a product you sell is \
        made up of multiple individual products (e.g. a multi-pack or a gift-box)`,
        Places: {
        }
      },
      Helper: {
        Content: `Select "Yes" even if it's something you don't need now \
        but might later.`,
        Places: {
        }
      },
      Submit: {
        Content: 'Next - Custom Packaging',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `Yes, I do have bundled products on my store`,
          Places: {}
        },
        No: {
          Content: `No, I have no need for bundled products`,
          Places: {}
        }
      }
    },
    CustomBoxes: { // seventh page
      Header: {
        Content: 'Custom Packaging & Kitting',
        Places: {
        }
      },
      SubText: {
        Content: `ShipBob provides standard packaging free of charge \
        ({readMorePackaging}). If you require customized packaging, we help \
        you set up your account accordingly.{br}Custom processes \
        that require special packing steps may require a kitting \
        request ({readMoreKitting}).`,
        Places: {
          readMorePackaging: 'details here',
          readMoreKitting: 'read more about kitting'
        }
      },
      Helper: {
        Content: `Select 'Yes' even if the occurrence will be rare.`,
        Places: {
        }
      },
      Submit: {
        Content: 'Next - Custom Box Preference',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `My items will ship in standard packaging`,
          Places: {}
        },
        No: {
          Content: `My items require custom packaging or treatment`,
          Places: {}
        }
      }
    },
    CustomBoxPreference: {
      Header: {
        Content: 'Custom Box Preference',
        Places: {
        }
      },
      SubText: {
        Content: `Do you prefer your orders packed in anything other than a standard box?{br} \
        We offer standard boxes, poly mailers, and standard packaging types ({readMoreCustomBoxPreference}) \
        We will default your account to boxes unless you specify otherwise.`,
        Places: {
          readMoreCustomBoxPreference: 'described here in more detail'
        }
      },
      Helper: {
        Content: `Select "Yes" even if it's something you don't need now \
        but might later.`,
        Places: {
        }
      },
      Submit: {
        Content: 'Next - Custom Settings',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `Yes, I would like some or all of my products packed in other packaging types`,
          Places: {}
        },
        No: {
          Content: `No, I would like all my items packed in boxes`,
          Places: {}
        }
      }
    },
    SpecialInventory: { // eigth page
      Header: {
        Content: 'Do any of your products require any special handling?',
        Places: {
        }
      },
      SubText: {
        Content: `Let us know if your products:{br} \
        {fragile}{hazard}{expire}{tracking}`,
        Places: {
          fragile: 'Are considered fragile',
          hazard: 'Contain dangerous goods or hazardous materials',
          expire: 'Have expiration dates or specific "lots"',
          tracking: 'Require serial number tracking'
        }
      },
      Helper: {
        Content: `Select "Yes" even if it's something you don't need now \
        but might later.`,
        Places: {
        }
      },
      Submit: {
        Content: 'Next - Wholesale/B2B',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `Yes, I may need special inventory treatment`,
          Places: {}
        },
        No: {
          Content: `No, my products do not require this service`,
          Places: {}
        }
      }
    },
    Wholesale: { // ninth page
      Header: {
        Content: 'Are you shipping wholesale (B2B) or case-packed orders?',
        Places: {
        }
      },
      SubText: {
        Content: `ShipBob offers convenient wholesale fulfillment - \
        we just have to make sure your account is set up the correct way ({b2bFullfillment}).`,
        Places: {
          b2bFullfillment: 'read more about B2B fulfillment here'
        }
      },
      Helper: {
        Content: ` `,
        Places: {
        }
      },
      Submit: {
        Content: 'Next - Invite your team',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `I am interested in shipping wholesale (B2B) orders`,
          Places: {}
        },
        No: {
          Content: `I will only ship directly to consumers (B2C)`,
          Places: {}
        }
      }
    },
    MultipleUsers: { // tenth page
      Header: {
        Content: 'Do you want to invite multiple users at your company?',
        Places: {
        }
      },
      SubText: {
        Content: `Currently, ShipBob allows you to invite your team free of charge. `,
        Places: {
        }
      },
      Helper: {
        Content: ` `,
        Places: {
        }
      },
      Submit: {
        Content: 'Next - Inactive Products',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `I want to invite my team`,
          Places: {}
        },
        No: {
          Content: `I am the only person who needs ShipBob access`,
          Places: {}
        }
      }
    },
    IgnoredProducts: { // eleventh page
      Header: {
        Content: `Do you have any products on your e-commerce store(s) you do \
        NOT want us to fulfill?`,
        Places: {
        }
      },
      SubText: {
        Content: `If you have digital products (e.g. e-books) or other \
        unfulfillable products, you just have to mark them accordingly \
        in our system to ensure you don't have delays with your actual \
        shippable inventory.`,
        Places: {
        }
      },
      Helper: {
        Content: ` `,
        Places: {
        }
      },
      Submit: {
        Content: 'Finish',
        Places: {
        }
      },
      Buttons: {
        Yes: {
          Content: `I have products that I don't want ShipBob to fulfill`,
          Places: {}
        },
        No: {
          Content: `I am only selling physical inventory I want \
          ShipBob to send out for me`,
          Places: {}
        }
      }
    },
    Yes: 'Yes',
    No: 'No'
  }
}
